// @flow
import * as React from 'react';
import { useEffect, useState } from 'react'
import { path, isNil, pathOr } from 'ramda';
import { useMutation, useQuery, useReactiveVar } from '@apollo/client';
import { getCSRFToken,fetchJSONWithErrorAlert } from "../../utils/http"
import useWhitelist from "../../hooks/use-whitelist"
import {useDispatch} from 'react-redux'
import { ShippingProfilesPaginated } from '../../shared-queries/ShippingProfiles.graphql';
import ANALYTICS from '../../analytics/shipping-profiles';
import { selectedShippingProfileVar } from '../../utils/apollo-cache';
import { useApolloLightbox } from '../../hooks/use-apollo-lightbox';
import ApolloLightbox from '../apollo-lightbox';
import classNames from 'classnames/bind';
import cs from './styles.pcss';
import ThreeColumnsLayout from "../../basic-components/three-columns-layout"
import Button from '../../basic-components/button';


const cx = classNames.bind(cs);


import {
  ShippingProfile,
  ShippingProfileAdditional,
  ShippingProfileSave,
  GetShowcases,
} from './operations.graphql';
import ShippingProfileLightboxForm from './form';
import {
  createEmptyProfile,
  convertToFormProfile,
  getDisabledColors,
} from './profile-utils';

import type { ShippingProfileSave_upsertProfile_profile as SavedProfile } from '../../typings/product-query.flow';

import { countryMapping } from "./flag-site-currency-marker/index"
type Props = {
  onSaveCompleted?: (profile: SavedProfile) => void,
};

// mock test
// const mockData = require('./mock/shipping-profile-data.json');
// const mockData = require('./mock/data2.json');

export default function ShippingProfileLightbox({
  onSaveCompleted,
}: Props): React.Node {
  const profileId = useReactiveVar(selectedShippingProfileVar);
  const isNew = profileId === '-1';
  // const dataIfWhitelist2 = require('./mock/shipping-profile-data3.json');



  const [duplicateProlife, setDuplicateProlife] = React.useState(null);
  const dispatch=useDispatch();
  const [cacheCount, setCacheCount] = React.useState(0);
  const [profile2, setprofile2] = useState({})
  const [worldwideCurrency, setWorldwideCurrency] = useState("USD")
  const [whitelist2GetProfileIsLoading, setwhitelist2GetProfileIsLoading] = useState(false)
  const { whitelist:whitelist2, fetchWhitelist } = useWhitelist();

  React.useEffect(() => {
    setDuplicateProlife(null);
  }, [isNew, profileId]);

  useEffect(() => {
    if((profileId==null)||(profileId==-1))return
    if(whitelist2==true){
      setwhitelist2GetProfileIsLoading(true)
      fetchJSONWithErrorAlert(`/shipping/profiles/${profileId}`,{},dispatch)
        .then((data) => {
          let temp=JSON.parse(JSON.stringify(data))
         setWorldwideCurrency(Object.keys(temp?.tariffsNew?.worldwide?.[0]?.price||{USD:"USD"})[0])
         let res=handleShippingProfileData({...data})
         setprofile2(res)
        }).catch(err => {
        }).finally(() => {
          setwhitelist2GetProfileIsLoading(false)
          // setTimeout(() => {
          // }, 2000);
        });
    }
  
  }, [profileId,whitelist2])

  const [onSave, { loading: submitting }] = useMutation(ShippingProfileSave, {
    update: (cache, result) => {
      const newProfile = path(['data', 'upsertProfile', 'profile'], result);
      const otherProfile = path(
        ['data', 'upsertProfile', 'otherProfile'],
        result
      );
      const success = path(['data', 'upsertProfile', 'success'], result);

      if (!success && otherProfile) {
        setDuplicateProlife(otherProfile.title);
        ANALYTICS.updateProfile(isNew, 'Duplicate');
      } else {
        ANALYTICS.updateProfile(isNew, success ? 'Success' : 'Error');
      }

      if (success) {
        selectedShippingProfileVar(-1)
        setCacheCount(cacheCount + 1);
      }

      if (success && duplicateProlife) {
        const { profiles } = cache.readQuery({
          query: ShippingProfilesPaginated,
          variables: { first: 30 },
        });

        const updatedProfilesNodes = [
          ...profiles.nodes.filter((p) => p.id !== profileId),
        ];

        const existingIndex = updatedProfilesNodes.findIndex(
          (p) => p.id === newProfile.id
        );

        if (existingIndex === -1) {
          updatedProfilesNodes.unshift(newProfile);
        } else {
          updatedProfilesNodes[existingIndex] = newProfile;
        }

        cache.writeQuery({
          query: ShippingProfilesPaginated,
          data: {
            profiles: {
              ...profiles,
              nodes: updatedProfilesNodes,
            },
          },
        });
        return;
      }

      if (success && isNew && newProfile) {
        const { profiles } = cache.readQuery({
          query: ShippingProfilesPaginated,
          variables: { first: 30 },
        });

        cache.writeQuery({
          query: ShippingProfilesPaginated,
          data: {
            profiles: {
              ...profiles,
              nodes: [newProfile, ...profiles.nodes],
            },
          },
        });
      }
    },
  });

  const {
    data: currenciesData,
    loading: currenciesLoading,
    error: currenciesError,
  } = useQuery(ShippingProfileAdditional);


  const { data, loading, error,refetch } = useQuery(ShippingProfile, {
    variables: { id: profileId },
    skip: isNew  || (profileId==-1)|| isNil(profileId)||whitelist2,
  });

  useEffect(() => {
    if((profileId==null)||(profileId==-1))return
    if (!isNew && !isNil(profileId) && !whitelist2) {
      console.log("refetch...start")
      refetch().then(res=>{
      console.log("refetch...end")
      }); 
    }
  }, [profileId]);


  const { data: cases } = useQuery(GetShowcases);

  const handleShippingProfileData = (profile) => {
    let { tariffsNew } = profile
    let res = {...profile}

    if(tariffsNew !=null){

      // handle all siteIds except worldwide
      let countryCodes = Object.keys(countryMapping).filter(item => item != "worldwide")
      for (let countryCode of countryCodes) {
        let siteShippingPolicyArr = tariffsNew[countryMapping[countryCode].siteId]

        // when tariffsNew object doesn't have some siteId key 
        // or the corresponding value of siteID is null or empty array,
        // initialize it with an empty array to display a blank line in the UI
        if (siteShippingPolicyArr == null || ((siteShippingPolicyArr instanceof Array) && siteShippingPolicyArr.length == 0)) {
          if(countryCode == "worldwide"){
            tariffsNew[countryCode] = [ { "shipping_level": "", "price":0, "additional_price": 0, "free_shipping": false } ]
          }else{
            tariffsNew[countryCode] = [ { "shipping_service": "", "price":0, "additional_price": 0, "free_shipping": false } ]
          }
        }else{
          for (const siteShippingPolicy of siteShippingPolicyArr) {
            const {price,additional_price}=siteShippingPolicy
            siteShippingPolicy["price"]=(Object.values(price||{})||[])[0]
            siteShippingPolicy["additional_price"]=(Object.values(additional_price||{})||[])[0]
          }
          
          // The data I got from xhr response is {0:xxx,2:xxx,3:xxx,15:xxx,71:xxx,77:xxx,101:xxx,186:xxx}
          // However, react-final-form will not recognize a numeric key
          // (it will detect whether the key is a numeric value and treat such object as an Array instead of a regular object...)
          // so I copy siteShippingPolicyArr from siteId(numeric value) to countryCode({us:xxx,de:xxx,it:xxx,fr:xxx,au:xxx...}) 
          // and pass this non-numeric key object as an initial value to the form.
          // reference: https://final-form.org/docs/react-final-form/faq#why-cant-i-have-numeric-keys-in-an-object
          tariffsNew[countryCode]=siteShippingPolicyArr
        }
      }

      // handle worldwide
      let worldwideShippingPolicyArr = tariffsNew["worldwide"]
      if(worldwideShippingPolicyArr?.length==0){
        tariffsNew["worldwide"]=[{}]
      }
      for (const worldwideShippingPolicy of worldwideShippingPolicyArr) {
        const {price,additional_price}=worldwideShippingPolicy
        worldwideShippingPolicy["price"]=(Object.values(price||{})||[])[0]
        worldwideShippingPolicy["additional_price"]=(Object.values(additional_price||{})||[])[0]
      }
     


    res = { ...profile, tariffsNew }
    }
  
    return res
  }


  const showcases = pathOr([], ['showcases'], cases);

  if (
    currenciesLoading ||
    currenciesError ||
    !currenciesData ||
    !currenciesData.viewer ||
    !currenciesData.profiles
  ) {
    return null;
  }

  const { currencies, viewer, profiles, profileTariffLocations, regions } =
    currenciesData;

  const account = viewer.accounts[0];
  const defaultCurrency = viewer.currency;
  const defaultItemLocation = {
    country: account.country || '',
    city: account.city,
    postalCode: account.postalCode,
  };


  // convert [{ code, name }, ...] to { [code]: name, ... }
  const shippingDestinations = profileTariffLocations.reduce(
    (names, region) => ({ ...names, [region.code]: region.name }),
    {}
  );

  const countries = regions.filter((region) => region.leaf);

  // 正常的
  const profile = data ? data.profile : null;


  // Mock Test
  // const { profile } = mockData.data;

  return (
<>
<ShippingProfileLightboxForm
      isNew={isNew}
      shippingProfile={
        isNew
          ? createEmptyProfile(defaultItemLocation,whitelist2)
          : convertToFormProfile(whitelist2 ? profile2 : profile, currencies, defaultCurrency, account)
      }
      duplicateProlife={duplicateProlife}
      countries={countries}
      defaultCurrency={defaultCurrency}
      disabledColorsMap={getDisabledColors(
        profiles.nodes,
        profile ? profile.id : null
      )}
      worldwideCurrency={worldwideCurrency}
      shippingDestinations={shippingDestinations}
      loading={(loading || whitelist2GetProfileIsLoading)&& !isNew}
      submitting={submitting}
      error={error}
      whitelist2={whitelist2}
      onSave={(profileInput) =>{
        if(whitelist2===false){
       return   onSave({
        variables: {
          input: {
            profile: profileInput,
            mergeEnabled: Boolean(duplicateProlife),
          },
        },
      })
        }
        return new Promise((resolve,reject)=>{
          let { tariffsNew } = profileInput
            let countryCodes = Object.keys(countryMapping).filter(item => item != "worldwide")
            for (let countryCode of countryCodes) {
              let siteId=countryMapping[countryCode].siteId
              let siteShippingPolicyArr = tariffsNew[countryCode]
              tariffsNew[siteId]=siteShippingPolicyArr
            }
            let worldwideShippingPolicyArr=tariffsNew.worldwide
            tariffsNew.worldwide=worldwideShippingPolicyArr.filter(x=>x.shipping_level !== "UNSET")
            let inputParams = { ...JSON.parse(JSON.stringify(profileInput)), tariffsNew:JSON.parse(JSON.stringify(tariffsNew)) }
            let siteIdKeys=Object.values(countryMapping).map(x=>x.siteId)||[]
            const {tariffsNew:_tariffsNew}=inputParams
            for (const key of countryCodes) {
              delete(_tariffsNew[key])
            }

            delete(inputParams.tariffs)

            fetchJSONWithErrorAlert(
              `/shipping/profiles/save`, {
              method: 'POST', // 指定请求方法为 POST
              headers: {
                'Content-Type': 'application/json' ,// 设置请求头，指示发送的是 JSON 数据
                'X-CSRF-Token': getCSRFToken(),
              },
              body: inputParams
            },dispatch,true
            )
            .then((data) => {
              const {success,errors}=data
              if(success){
                console.log("resolve")
                selectedShippingProfileVar(-1)
                resolve()
              }else{
                console.log("reject")
                reject(errors)
              }
            }).catch(err=>{
            console.log("reject")
            reject()
            }) 
        
        })
      }
      }
      onSaveCompleted={onSaveCompleted}
      showcases={showcases}
      cacheCount={cacheCount}
    />
  </>
  );
}
